<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m4RSGr/tc-custom/Cover.jpg?1688985128846?1714677663517" alt="This image is the cover for the book Angel Vol. 1, Angel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Angel Vol. 1, Angel
      </h1>
      <p class="bookDescription body article font2">
        <p>Angel walks the line between two worlds; a vampire cursed with a soul, he’s spent centuries battling back the forces that would destroy humanity, in an attempt to redeem himself for the crimes committed by the monster he was when he was first turned. But now, on the trail of the most recent demonic uprising, he realizes that the redemption he seeks can only come with a price. Torn between his self-sworn mission to protect humanity and his desire to rid himself of his curse, he stumbles across the legend of a demon, a trickster who claims they can cure vampirisim and restore his humanity for a small cost: a sacrifice...a Slayer. Written by Bryan Hill (Detective Comics, Hulu’s Titans) with art from Gleb Melnikov. Discover a brand new, modern take on one of the best and broodiest vampires in pop culture, perfect for fans and new readers alike!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bryan Edward Hill, Joss Whedon, Gleb Melnikov, Gabriel Cassata
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59de4170